import Player from "react-lottie-player/dist/LottiePlayerLight";
import path from "./LoadingLottie.json?url";

export function LoadingAnimation() {
    return <Player path={path} loop play speed={1} />;
}
